import { baseApi } from "./apiConfig";

export const getFcListingsInfoPostSale = async (address, caseFileNumber, pageNumber = 1) => {
  try {
    const response = await baseApi.get(`/portal/getFcListingsInfoPostSale?pageNumber=${pageNumber}`, {
      params: {
        address: address || '',
        caseFileNumber: caseFileNumber || '',
      }
    });
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      throw response;
    }
  } catch (error) {
    console.error('getFcListingsInfoPostSale error', error);
    throw error;
  }
};
